import gql from 'graphql-tag'

export const GET_ORGANIZATION_PREPAID_COUPON_AND_INTEREST_AND_EVENT_TEMPLATE = gql`
  query GetOrganizationPrepaidCouponAndInterestAndEventTemplate($organizationSlug: String!) {
    getOrganizationPrepaidCoupons(organizationSlug: $organizationSlug) {
      id
      name
      price
      currency
      description
      from
      to
      couponItems {
        id
        type
        eventTemplateId
        ticketAmount
        genres {
          id
        }
        tags {
          id
        }
        performanceTypes
      }
    }
    getOrganizationEventTemplates(organizationSlug: $organizationSlug) {
      id
      title
    }
    getOrganizationInterest(organizationSlug: $organizationSlug) {
      id
      name
      categoryId
      type
    }
  }
`

export const GET_SPORT_PREPAID_COUPONS = gql`
  query GetSportOrganizationPrepaidCoupons($organizationSlug: String!) {
    getSportOrganizationPrepaidCoupons(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`

export const GET_SPORT_PREPAID_COUPONS_WITH_EVENTS_AND_ORGANIZATION = gql`
  query GetSportOrganizationPrepaidCoupons($organizationSlug: String!) {
    getSportOrganizationPrepaidCoupons(organizationSlug: $organizationSlug) {
      id
      name
      price
      currency
      description
      from
      to
      couponItems {
        id
        type
        ticketAmount
        eventIds
      }
      prepaidCouponUser {
        id
      }
    }
    getTicketingEventsByOrganizationSlug(organizationSlug: $organizationSlug) {
      id
      title
      from
      to
    }
    getOrganizationBySlug(organizationSlug: $organizationSlug) {
      id
      imageUrls
    }
  }
`

export const CREATE_ORGANIZATION_PREPAID_COUPON = gql`
  mutation CreateOrganizationPrepaidCoupon(
    $organizationSlug: String!
    $prepaidCouponInput: PrepaidCouponInput!
  ) {
    createOrganizationPrepaidCoupon(
      organizationSlug: $organizationSlug
      prepaidCouponInput: $prepaidCouponInput
    )
  }
`

export const CREATE_SPORT_ORGANIZATION_PREPAID_COUPON = gql`
  mutation CreateSportOrganizationPrepaidCoupon(
    $organizationSlug: String!
    $prepaidCouponInput: SportPrepaidCouponInput!
  ) {
    createSportOrganizationPrepaidCoupon(
      organizationSlug: $organizationSlug
      prepaidCouponInput: $prepaidCouponInput
    )
  }
`

export const UPDATE_ORGANIZATION_PREPAID_COUPON = gql`
  mutation UpdateOrganizationPrepaidCoupon(
    $organizationSlug: String!
    $prepaidCouponInput: PrepaidCouponInput!
  ) {
    updateOrganizationPrepaidCoupon(
      organizationSlug: $organizationSlug
      prepaidCouponInput: $prepaidCouponInput
    )
  }
`

export const UPDATE_SPORT_ORGANIZATION_PREPAID_COUPON = gql`
  mutation UpdateSportOrganizationPrepaidCoupon(
    $organizationSlug: String!
    $prepaidCouponInput: SportPrepaidCouponInput!
  ) {
    updateSportOrganizationPrepaidCoupon(
      organizationSlug: $organizationSlug
      prepaidCouponInput: $prepaidCouponInput
    )
  }
`

export const DELETE_ORGANIZATION_PREPAID_COUPON = gql`
  mutation DeleteOrganizationPrepaidCoupon($organizationSlug: String!, $prepaidCouponIds: [Int!]!) {
    deleteOrganizationPrepaidCoupon(
      organizationSlug: $organizationSlug
      prepaidCouponIds: $prepaidCouponIds
    )
  }
`
